import icon from "../../../assets/ecgs/interpretation.svg";
import disabledIcon from "../../../assets/ecgs/interpretation_disabled.svg";
import selectedIcon from "../../../assets/ecgs/interpretation_selected.svg";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import StateIcon from "../StateIcon/StateIcon";
import styles from "./InterpretationIcon.module.css";

type InterpretationIconProps = {
  disabled?: boolean;
  selected?: boolean;
  hovered?: boolean;
};

const InterpretationIcon = ({
  disabled,
  selected,
  hovered,
  className,
}: PropsWithClassName<InterpretationIconProps>) => {
  return (
    <StateIcon
      className={`${styles.icon} ${className}`}
      iconSrc={icon}
      selected={{
        iconSrc: selectedIcon,
        value: selected ?? false,
      }}
      disabled={{
        iconSrc: disabledIcon,
        value: disabled ?? false,
      }}
      hovered={{
        iconSrc: selectedIcon,
        value: selected ? false : hovered!,
      }}
    />
  );
};
export default InterpretationIcon;
